import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';
import { CakeItEasyWebUiModule } from '@cakeiteasy/web-ui';

import { RegisterAnAccountComponent } from './components/register-an-account/register-an-account.component';
import { CustomerDetailsPartialComponent } from './components/customer-details-partial/customer-details-partial.component';
import { ReceiptHeaderPartialComponent } from './components/receipt-header-partial/receipt-header-partial.component';
import { RememberPartialComponent } from './components/remember-partial/remember-partial.component';
import { OrderInfoPartialComponent } from './components/order-info-partial/order-info-partial.component';
import { ReturnInfoPartialComponent } from './components/return-info-partial/return-info-partial.component';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    TranslateModule,
    CakeItEasyWebUiModule,
    NgCakeItEasyUtilsModule,
    ReturnInfoPartialComponent,
  ],
  declarations: [
    RegisterAnAccountComponent,
    CustomerDetailsPartialComponent,
    OrderInfoPartialComponent,
    ReceiptHeaderPartialComponent,
    RememberPartialComponent,
  ],
  exports: [
    RegisterAnAccountComponent,
    CustomerDetailsPartialComponent,
    OrderInfoPartialComponent,
    ReceiptHeaderPartialComponent,
    RememberPartialComponent,
    ReturnInfoPartialComponent,
  ]
})
export class ReceiptModule {

}
